var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"doc-icon",attrs:{"src":_vm.returnFileType()}})])
}
var staticRenderFns = []

export { render, staticRenderFns }